<script lang="ts">
    import OperationHead from "./edit/OperationHead.svelte"
    export let operation: OperationOut
    let outerWidth: number
</script>

<svelte:window bind:outerWidth />

<OperationHead bind:operation />
